import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Socket } from 'socket.io-client';
@Injectable({
  providedIn: 'root'
})
export class BrowserDataService {
  private baseUrlBrowser: any = environment.baseUrlBrowser;
  private isBrowserSocketConnected = false;
  private wsBrowserUpdates: Socket | null = null;
  // private baseUrlBrowser='http://192.168.13.50:5050'
  // private apiUrl = 'https://axisprotean.apmosys.com/nbrowser/';
  private NgasaUrl: any = environment.NgasaUrl;

  constructor(private http: HttpClient) { }


  getBaseUrl(url: string): string {
    const doubleSlashIndex = url.indexOf("//");
    if (doubleSlashIndex === -1) return "";

    const startIndex = doubleSlashIndex + 2;
    const endIndex = url.indexOf("/", startIndex);

    if (endIndex === -1) {
      return url; // No path — return full string (e.g., https://domain.com)
    }

    return url.substring(0, endIndex);
  }
  // Function to track browser socket connection status
  getBrowserSocketConnectionStatus(): boolean {
    return this.isBrowserSocketConnected;
  }

  // Function to set browser socket connection status
  setBrowserSocketConnectionStatus(status: boolean): void {
    this.isBrowserSocketConnected = status;
  }

  getSocketInstance(): Socket | null {
    return this.wsBrowserUpdates;
  }

  setSocketInstance(socket: Socket): void {
    this.wsBrowserUpdates = socket;
  }

  // Function to disconnect the browser WebSocket
  disconnectBrowserWebSocket(): void {
    if (this.wsBrowserUpdates) {
      this.wsBrowserUpdates.disconnect();
      this.wsBrowserUpdates = null;
      this.isBrowserSocketConnected = false;
    }
  }

  // Get list of all browsers
  getBrowserList(group: string): Observable<any> {
    return this.http.get(this.baseUrlBrowser + '/getBrowserDetails', {
      params: { group },
      withCredentials: true,
    });
  }


  // Get single browser by ID
  getBrowserById(browserId: string): Observable<any> {
    return this.http.get(this.baseUrlBrowser + `/getBrowser/${browserId}`, { withCredentials: true });
  }

  // Save browser (create new or update existing)
  saveBrowser(browser: any): Observable<any> {
    return this.http.post(this.baseUrlBrowser + '/saveBrowser', browser, { withCredentials: true });
  }

  // Update existing browser
  updateBrowser(browser: any): Observable<any> {
    return this.http.put(this.baseUrlBrowser + '/updateBrowser', browser, { withCredentials: true });
  }

  // Delete single browser by ID
  deleteBrowser(browserId: string): Observable<any> {
    return this.http.delete(this.baseUrlBrowser + `/deleteBrowser/${browserId}`, { withCredentials: true });
  }

  // Delete all browsers
  deleteAllBrowsers(): Observable<any> {
    return this.http.delete(this.baseUrlBrowser + '/deleteAllBrowsers', { withCredentials: true });
  }

  // Legacy methods - keeping for backward compatibility
  updateUserStatus(user: any): Observable<any> {
    return this.http.post(this.baseUrlBrowser + '/browserAcquisition', user);
  }

  updateUserStatusToFalse(user: any): Observable<any> {
    return this.http.post(this.baseUrlBrowser + '/browserRelease', user)
    // .pipe(
    //   tap(response => {
    //     let data = new FormData();
    //     data.append('email', user.mail);

    //     fetch(`${this.NgasaUrl}/api/px/stopExecution`, {
    //       method: 'PUT',
    //       body: data
    //     })
    //       .then(response => {
    //         if (!response.ok) {
    //           throw new Error(`HTTP error! Status: ${response.status}`);
    //         }
    //         console.log('Stop execution API called successfully');
    //       })
    //       .catch(error => {
    //         console.error('Stop execution API failed:', error);
    //       });
    //   })
    // );
  }

}
